import React, {useState,useEffect} from 'react';
import noteContext from './NoteContext';


const NoteState=(props)=>{
    const [expenseList, setExpenseList] = useState([]);
    const [edittmp, setedittmp] = useState({});
    const [ind, setind] = useState({})
    const [categories, setCategories] = useState([])
    const [isModal, setisModal] = useState(false)
    const [modalType, setModalType] = useState("null")
    const [allCat, setAllCat] = useState({})
    const [isProfile, setIsProfile] = useState(false)
    const [Income, setIncome] = useState(0)
    const [Expense, setExpense] = useState(0)
    const [selectedCurrency, setSelectedCurrency] = useState({ code: 'PKR', symbol: 'Rs' });
    const [searchQuery, setSearchQuery] = useState("");
    const [isMenuOpen,setIsMenuOpen]= useState(false)
    const [isSearch,setIsSearch]= useState(false)
    const [mobileSearch,setMobileSearch]= useState(false)

    

    const value={expenseList, setExpenseList,
      edittmp, setedittmp,
      ind, setind,
      categories, setCategories,
      isModal, setisModal,
      modalType, setModalType,
      allCat, setAllCat,
      isProfile, setIsProfile,
      Income, setIncome,
      Expense, setExpense,
      selectedCurrency, setSelectedCurrency,
      searchQuery, setSearchQuery,
      isMenuOpen,setIsMenuOpen,
      isSearch,setIsSearch,
      mobileSearch,setMobileSearch}


          
    useEffect(() => {
        const Expense = expenseList.reduce((sum, item) => sum + (item.type === "Expense" ? Number(item.amount) : 0), 0);
        const Income = expenseList.reduce((sum, item) => sum + (item.type === "Income" ? Number(item.amount) : 0), 0);
        setIncome(Income);
        setExpense(Expense);
    }, [expenseList]);

    return(
    <noteContext.Provider value={value} >{props.children}</noteContext.Provider>
)}
export default NoteState